export function quoteSlider() {
    let $quoteParentBlock = $(".quote-section");
    let $quoteSlider = $(".quote-slider");
    let $quoteSliderMedia = $(".quote-section > .section-bg");
    let $win = $(window);

    let initSlidersWithVideo = function () {
        let $videoHolders = $("[data-quote-video-src]");

        $videoHolders.each(function (){
            let $th = $(this);

            if ($th.attr("data-quote-video-src").indexOf("youtube") !== -1) {
                $th.append($(`<iframe width="100%" height="100%" style="border: none;" src="${$th.attr("data-quote-video-src")}?background=1&autoplay=1&loop=0&byline=0&title=0&mute=1&amp;controls=0" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`));
            } else {
                $th.append($("<video class='video' preload='metadata' autoplay muted playsinline><source src='" + $th.attr("data-quote-video-src") + "' type='video/mp4'></video>"));
            }
        });

        if ($(".quote-slider-item").length > 1) {

            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    let $slider = $(entry.target);

                    if (entry.isIntersecting) {
                        $slider.slick("slickPlay");

                        if (!$slider.hasClass("init")) {
                            $slider.slick("slickGoTo", 0);
                            $slider.addClass("init");
                        }
                    } else {
                        $slider.slick("slickPause");
                    }
                });
            });

            $quoteSlider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                mobileFirst: true,
                infinite: false,
                dots: true,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 6000,
                asNavFor: $quoteSliderMedia,
                pauseOnFocus: false,
                pauseOnHover: false,
            });

            $quoteSliderMedia.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                mobileFirst: true,
                infinite: true,
                dots: false,
                arrows: false,
                fade: true,
            });

            $quoteSlider.each(function () {
                observer.observe(this);
            });
        }
    }

    if ($quoteParentBlock.offset().top - $win.scrollTop() < 500 && !$quoteSlider.hasClass("slick-initialized")) {
        initSlidersWithVideo();
    }

    $win.on("resize, scroll", function () {
        if ($quoteParentBlock.offset().top - $win.scrollTop() < 500 && !$quoteSlider.hasClass("slick-initialized")) {
            initSlidersWithVideo();
        }
    });
};


// WEBPACK FOOTER //
// ./assets/js/modules/quoteSlider.js